"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FormMessage = require("./FormMessage");
Object.keys(_FormMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormMessage[key];
    }
  });
});